<template>
	<div class="eia-faq-item-summary">
		<eia-heading level="h3">{{ title }}</eia-heading>
		<p v-html="body"></p>
	</div>
</template>

<script>
import { urlSafe } from '@/utils/string-utils';

export default {
	name: 'eia-faq-item-summary',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},

	computed: {
		title() {
			return this.item.title;
		},

		body() {
			return this.item.body;
		},

		author() {
			return this.item.author;
		},

		link() {
			return {
				path: `/faq/${urlSafe( this.item.title )}`,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-faq-item-summary {
	margin: 24px 0;
	border: 1px solid $color-grey-light;
	border-radius: $radius-default;
	padding: 24px;
	box-shadow: 0 2px 4px rgba( $color-grey-dark, 0.25 );
	color: $color-main;
	text-decoration: none;
	display: block;
}
.eia-faq-item-summary p {
	margin-bottom: 0;
}
</style>
